import React from 'react'
import { AppPage } from '../layouts/types';
import KebabMenuTable from '../components/popover/KebabMenuTable';
import KebabMenuParticipants from '../components/popover/KebabMenuParticipants';

const ExitSession: AppPage = () => {
  return (
    <>
      <div className="grid grid-cols-3 gap-4 justify-items-center">
        <div className="flex col-span-1">
          <ExitSession />
        </div>
        <div className="flex col-span-1">
          <KebabMenuTable />
        </div>
        <div className="flex col-span-1">
          <KebabMenuParticipants />
        </div>
      </div>
    </>
  );
};

export default ExitSession;